const NUMERIC_STRING = (value: string) => value.replace(/\D/g, '')

const PURE_NUMBER = (value: string) => Number(value.replace(/\D/g, ''))

// ==========================================================================================
// NUMBER

const INPUT_NUMBER = (value: string) => PURE_NUMBER(String(value) || '')

// ==========================================================================================
// CPF

const INPUT_CPF = (value: string) => CPF(CPF_TO_NUMBER(value))

const CPF = (value: string | number) => {
  let strValue = String(value)
  if (strValue.length > 11) strValue = strValue.slice(0, 11)

  if (strValue.length <= 6) {
    strValue = strValue.replace(/^(\d{3})(\d)/, '$1.$2')
  } else if (strValue.length <= 9) {
    strValue = strValue.replace(/^(\d{3})(\d{3})(\d)/, '$1.$2.$3')
  } else {
    strValue = strValue.replace(/^(\d{3})(\d{3})(\d{3})(\d)/, '$1.$2.$3-$4')
  }

  return strValue
}

const CPF_TO_NUMBER = (value: string | number) => NUMERIC_STRING(String(value))

// ====================================================================================================
// CNPJ

const INPUT_CNPJ = (value: string) => CNPJ(CNPJ_TO_NUMBER(value))

const CNPJ = (value: string | number) => {
  let strValue = String(value)
  if (strValue.length > 14) strValue = strValue.slice(0, 14)

  if (strValue.length <= 5) {
    strValue = strValue.replace(/^(\d{2})(\d)/, '$1.$2')
  } else if (strValue.length <= 8) {
    strValue = strValue.replace(/^(\d{2})(\d{3})(\d)/, '$1.$2.$3')
  } else if (strValue.length <= 12) {
    strValue = strValue.replace(/^(\d{2})(\d{3})(\d{3})(\d)/, '$1.$2.$3/$4')
  } else {
    strValue = strValue.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d)/,
      '$1.$2.$3/$4-$5',
    )
  }

  return strValue
}

const CNPJ_TO_NUMBER = (value: string | number) => NUMERIC_STRING(String(value))

// ==========================================================================================
// CPF - CNPJ

const INPUT_CPF_CNPJ = (value: string) => CPF_CNPJ(CPF_CNPJ_TO_NUMBER(value))

const CPF_CNPJ = (value: string | number) => {
  let strValue = String(value)
  if (strValue.length > 14) strValue = strValue.slice(0, 14)

  if (strValue.length <= 6) {
    strValue = strValue.replace(/^(\d{3})(\d)/, '$1.$2')
  } else if (strValue.length <= 9) {
    strValue = strValue.replace(/^(\d{3})(\d{3})(\d)/, '$1.$2.$3')
  } else if (strValue.length <= 12) {
    strValue = strValue.replace(/^(\d{2})(\d{3})(\d{3})(\d)/, '$1.$2.$3/$4')
  } else {
    strValue = strValue.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d)/,
      '$1.$2.$3/$4-$5',
    )
  }

  return strValue
}

const CPF_CNPJ_TO_NUMBER = (value: string | number) =>
  NUMERIC_STRING(String(value))

// ====================================================================================================
// TELEFONE

const INPUT_TELEFONE = (value: string) => TELEFONE(TELEFONE_TO_NUMBER(value))

const TELEFONE = (value: number) => {
  let strValue = String(value === 0 ? '' : value)
  if (strValue.length > 11) strValue = strValue.slice(0, 11)

  if (strValue.length <= 6) {
    strValue = strValue.replace(/^(\d{2})(\d{1,4})/, '($1) $2')
  } else if (strValue.length <= 10) {
    strValue = strValue.replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3')
  } else {
    strValue = strValue.replace(
      /^(\d{2})(\d{1})(\d{4})(\d{4})/,
      '($1) $2 $3-$4',
    )
  }

  return strValue
}

const TELEFONE_TO_NUMBER = (value: string | number) =>
  PURE_NUMBER(String(value))

// ====================================================================================================
// CEP

const INPUT_CEP = (value: string) => CEP(CEP_TO_NUMBER(value))

const CEP = (value: string | number) => {
  let strValue = String(value)
  if (strValue.length > 8) strValue = strValue.slice(0, 8)

  strValue = strValue.replace(/^(\d{5})(\d)/, '$1-$2')

  return strValue
}

const CEP_TO_NUMBER = (value: string | number) => NUMERIC_STRING(String(value))

// ====================================================================================================
// NO MASK

const INPUT_NO_MASK = (value: string) => value

// ====================================================================================================
// EXPORT

export const InputMasks = {
  INPUT_CPF,
  INPUT_CNPJ,
  INPUT_CPF_CNPJ,
  INPUT_TELEFONE,
  INPUT_CEP,
  INPUT_NUMBER,
  INPUT_NO_MASK,
}

export const TextMasks = {
  PURE_NUMBER,
  //
  CPF,
  CPF_TO_NUMBER,
  //
  CNPJ,
  CNPJ_TO_NUMBER,
  //
  CPF_CNPJ,
  CPF_CNPJ_TO_NUMBER,
  //
  TELEFONE,
  TELEFONE_TO_NUMBER,
  //
  CEP,
  CEP_TO_NUMBER,
}
